import { Component, OnDestroy, OnInit} from '@angular/core';
import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';


import { UserData } from '../../../@core/data/users';
import { LayoutService } from '../../../@core/utils';
import { filter, map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { KeycloakSecurityService } from '../../../Keycloak-config/keycloak-security.service';
import { OrganizationsService } from '../../../Services/organizations/organizations.service';
import { environment } from '../../../../environments/environment';
import { Organization } from '../../../Models/organization/entities/organization.entity';
import {Router} from "@angular/router";

interface CardSettings {
  title: string;
  iconClass: string;
  type: string;
}

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy
{
  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  user: any;
  nbmenuService= new NbMenuService();

  organization: Organization;
  private organization_id: string = environment.ORGANIZATION_ID;
  organizations: any[] = [];

  selectedOrganizationId: string;
  isAdmin: boolean = false;

  emergencyStatusCard: CardSettings =
  {
    title: 'SI de Secours',
    iconClass: 'nb-danger',
    type: 'danger',
  };
  emergencyModeDetails =
  {
    type: 'danger',
    content: "L'activation du SI de Secours permet de <strong>démarrer tous les services et de notifier tous les utilisateurs.</strong> \
    Les utilisateurs seront alors dirigés sur le site web de communication d'urgence, et pourront configurer leur nouveau mot de passe pour accéder aux services."
  }

  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];


  currentTheme = 'default';


  // userMenu = [ { title: 'Profile' }, { title: 'Log out'} ];
  userMenu = [ { title: 'Déconnexion'} ];
  tag = 'my-context-menu';



  fullName: string;
  constructor(private sidebarService: NbSidebarService,
              private menuService: NbMenuService,
              private themeService: NbThemeService,
              private userService: UserData,
              private layoutService: LayoutService,
              private breakpointService: NbMediaBreakpointsService,
              private securityService: KeycloakSecurityService,
              private organizationsService: OrganizationsService,
              private router: Router
  ) {
                this.securityService.kc.loadUserProfile().then(data => {
                  this.fullName = data.firstName + " " + data.lastName;
                })
                menuService.onItemClick().pipe(filter(({ tag }) => {
                  return tag === this.tag
                }))
                .subscribe(bag => {
                  if(bag.item.title==='Déconnexion'){
                    this.securityService.kc.logout();
                }});
  }


  ngOnInit() {
    // initialize organization only if not admin
    this.isAdmin = this.securityService.kc.tokenParsed.realm_access.roles.includes('admin');

    if (this.isAdmin) {
      // Fetch organizations and set the first one as the default
      this.organizationsService.organizations$.subscribe((organizations) => {
        this.organizations = organizations;
        if (organizations.length > 0 && !this.organizationsService.getSelectedOrganizationId()) {
          this.organizationsService.setSelectedOrganizationId(organizations[0].organization_id); // Set default
        }
        this.selectedOrganizationId = this.organizationsService.getSelectedOrganizationId();
      });

      // L'affichage du selecteur doit suivre la selection reelle, y compris lorsqu'elle
      // change ailleurs que par un clic sur ce selecteur.
      this.organizationsService.selectedOrganizationId$
        .pipe(takeUntil(this.destroy$))
        .subscribe((organizationId) => {
          if (organizationId) {
            this.selectedOrganizationId = organizationId;
          }
        });
    } else {
      // Non-admin logic
      this.organization = new Organization(this.organization_id.toUpperCase(), null, null);
    }

    this.currentTheme = this.themeService.currentTheme;
    this.userService.getUsers()
      .pipe(takeUntil(this.destroy$))
      .subscribe((users: any) => this.user = users.default);


    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);


    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);
  }


  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }


  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  onOrganizationChange(organizationId: string) {
    this.organizationsService.setSelectedOrganizationId(organizationId);
    const currentUrl = this.router.url;

    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigateByUrl(currentUrl);
    });
  }


  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();


    return false;
  }


  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }


  logout(): void{
    this.securityService.kc.logout();
  }
  onMenuItemClick(){
    this.securityService.kc.logout();
  }
}
